import { inject, Injectable } from '@angular/core';
import { ApiCallingV2Service, ApiResponseModel, ResponseUtilityService, API_CONFIG } from '@zayan-erp/shared';
import { map, Observable } from 'rxjs';
import { salesReportModel, salesReportResponseModel } from '../models/sales-dashboard.models';

@Injectable({
  providedIn: 'root'
})
export class SalesDashboardService {
  #http = inject(ApiCallingV2Service);
  #apiConfig = inject(API_CONFIG);
  baseUrl = this.#apiConfig.baseUrlV2;

  constructor() {}

  getSalesReport(req: salesReportModel): Observable<salesReportResponseModel> {
    return this.#http.getData<salesReportResponseModel>(
      `${this.baseUrl}/sales-report?ProjectId=${req.projectId}&FromDate=${req.fromDate}&ToDate=${req.toDate}`,
      { showLoader: false, showMessage: false }
    );
  }
}
